import { Link } from "react-router-dom";
import AnimatedSection from "../../../components/base/AnimatedSection";

const services = [
  {
    icon: "ri-file-list-3-line",
    number: "01",
    title: "Gestión Administrativa",
    description: "Gestionamos la documentación completa de tu competición: inscripciones de equipos, altas de jugadores, actas de partido, calendarios de jornadas y toda la documentación oficial requerida. Tu liga organizada desde el primer día hasta el último.",
    features: [
      "Inscripción y alta de equipos y jugadores",
      "Elaboración y gestión de actas",
      "Calendarios de competición",
      "Archivo y custodia documental",
      "Comunicaciones oficiales a participantes",
    ],
  },
  {
    icon: "ri-secure-payment-line",
    number: "02",
    title: "Gestión Fiscal y Legal",
    description: "Nos encargamos de todos los pagos a árbitros y colaboradores con pleno cumplimiento tributario. Eliminamos el riesgo legal del organizador: sin retenciones mal aplicadas, sin pagos en negro, sin inspecciones sorpresa. Seguridad jurídica total.",
    features: [
      "Pagos con retención IRPF correcta",
      "Modelos 111 y 190 presentados",
      "Cumplimiento normativa laboral deportiva",
      "Protección ante inspecciones de Hacienda",
      "Asesoría fiscal especializada en deporte amateur",
    ],
  },
  {
    icon: "ri-whistle-line",
    number: "03",
    title: "Coordinación de Árbitros",
    description: "Seleccionamos, formamos y asignamos los árbitros de cada jornada. Gestionamos su disponibilidad, comunicación y presencia. Garantizamos la remuneración correcta y puntual de cada árbitro en cada partido.",
    features: [
      "Base de datos de árbitros cualificados",
      "Asignación automatizada por jornada",
      "Gestión de sustituciones y bajas",
      "Control de presencia en campo",
      "Remuneración garantizada y puntual",
    ],
  },
  {
    icon: "ri-team-line",
    number: "04",
    title: "Gestión de Colaboradores",
    description: "Coordinamos a todo el personal auxiliar de tu competición: anotadores, auxiliares de campo, responsables de instalaciones y cualquier colaborador necesario. Sus pagos, gestionados con todas las garantías legales.",
    features: [
      "Coordinación de anotadores y auxiliares",
      "Personal de control de accesos",
      "Responsables de instalaciones",
      "Pagos legalmente gestionados",
      "Comunicación centralizada con todo el equipo",
    ],
  },
  {
    icon: "ri-bar-chart-grouped-line",
    number: "05",
    title: "Control y Trazabilidad de Pagos",
    description: "Mantenemos un registro detallado y auditado de cada movimiento económico de la competición. Ante cualquier reclamación, inspección o auditoría, dispondrás de documentación completa y ordenada que demuestre el cumplimiento total.",
    features: [
      "Registro completo de todos los pagos",
      "Justificantes por árbitro y jornada",
      "Informes mensuales y anuales",
      "Protección ante reclamaciones",
      "Transparencia total con el organizador",
    ],
  },
  {
    icon: "ri-customer-service-2-line",
    number: "06",
    title: "Soporte Operativo Continuo",
    description: "Somos tu partner permanente durante toda la temporada. No desaparecemos tras firmar el contrato — estamos en cada jornada, resolviendo incidencias, gestionando imprevistos y dando respaldo profesional cuando lo necesitas.",
    features: [
      "Atención directa durante toda la temporada",
      "Resolución rápida de incidencias",
      "Gestión de reclamaciones de equipos",
      "Informes de seguimiento periódicos",
      "Revisión y mejora continua del proceso",
    ],
  },
];

export default function ServicesGrid() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {services.map((service, i) => (
          <AnimatedSection key={service.number} delay={i * 60}>
            <div
              className={`flex flex-col lg:flex-row gap-12 py-14 border-b border-brand-pearl ${
                i % 2 !== 0 ? "lg:flex-row-reverse" : ""
              }`}
            >
              {/* Number + icon */}
              <div className="lg:w-1/3 flex-shrink-0">
                <div className="flex items-center gap-4 mb-6">
                  <span className="font-heading font-black text-brand-pearl text-7xl leading-none select-none">
                    {service.number}
                  </span>
                  <div className="w-12 h-12 flex items-center justify-center rounded-md border border-brand-pearl">
                    <i className={`${service.icon} text-2xl text-brand-red`}></i>
                  </div>
                </div>
                <h3 className="font-heading font-black text-brand-black leading-tight mb-4"
                  style={{ fontSize: "clamp(1.5rem, 3vw, 2.2rem)" }}>
                  {service.title}
                </h3>
                <div className="w-12 h-0.5 mb-4" style={{ backgroundColor: "#E8150C" }}></div>
                <p className="font-body text-brand-gray-mid text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>

              {/* Features list */}
              <div className="lg:w-2/3">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {service.features.map((feat) => (
                    <div key={feat} className="flex items-start gap-3 p-5 bg-brand-pearl rounded-lg">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-brand-red text-base"></i>
                      </div>
                      <span className="font-body text-brand-anthracite text-sm leading-relaxed">
                        {feat}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </AnimatedSection>
        ))}

        {/* CTA */}
        <AnimatedSection delay={100}>
          <div className="flex justify-center pt-16">
            <Link
              to="/#contacto"
              onClick={() => {
                setTimeout(() => {
                  const el = document.getElementById("contacto");
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                }, 100);
              }}
              className="bg-brand-red hover:bg-brand-red-hover text-white font-body font-medium px-12 py-5 rounded-md transition-colors cursor-pointer whitespace-nowrap text-base"
            >
              Solicitar información
            </Link>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}